module.exports = "../dist/img/product-detail-1-45.5e9b.jpg";